"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLuna = void 0;
const fabricators_1 = require("../../fabricators");
const queries_1 = require("../../queries");
const operation_1 = require("../operation");
class BLuna {
    constructor(lcd, addressProvider) {
        this._lcd = lcd;
        this._addressProvider = addressProvider;
    }
    mint(mintOption) {
        return new operation_1.OperationImpl(fabricators_1.fabricatebLunaBond, mintOption, this._addressProvider);
    }
    burn(burnOption) {
        return new operation_1.OperationImpl(fabricators_1.fabricatebLunaUnbond, burnOption, this._addressProvider);
    }
    instantBurn(instantiateBurnOption) {
        return new operation_1.OperationImpl(fabricators_1.fabricateExchangeSwapbLuna, instantiateBurnOption, this._addressProvider);
    }
    withdraw() {
        return new operation_1.OperationImpl(fabricators_1.fabricatebLunaWithdrawUnbonded, {}, this._addressProvider);
    }
    getUnbondRequests(getUnbondRequestsOption) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, queries_1.queryHubUnbond)(Object.assign({ lcd: this._lcd }, getUnbondRequestsOption))(this._addressProvider);
        });
    }
}
exports.BLuna = BLuna;
//# sourceMappingURL=bluna.js.map